
import { NoseurObject } from "@rivtn/noseur";
import { JanuariusBaseService } from "./JanuariusBaseService";

export interface IBusinessAccessCredential {
    created_at: string;
}

export class BusinessAccessCredentialService extends JanuariusBaseService {

    protected static instance: BusinessAccessCredentialService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!BusinessAccessCredentialService.instance) BusinessAccessCredentialService.instance = new BusinessAccessCredentialService();
        return BusinessAccessCredentialService.instance;
    }

    generatePlatformAccessToken(payload: NoseurObject<any>) {
        return this.report(this.transport.post(`/janus/januarius/api/v1/administration/business/access/credential/generate`, payload));
    }

}

